import React from 'react';

export default function NameCell({ firstName, lastName, email, path }) {
  const fullName = [firstName, lastName].filter(Boolean).join(' ');
  return (
    <a href={path} className="d-block text-reset text-decoration-none">
      <div className="font-weight-bold">{fullName}</div>
      <div className="text-muted small">{email}</div>
    </a>
  );
}
